import { GameObjectManager } from "../GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { math, SavaneMath } from "@rhinov/savane-js";

declare var cc: any;

export class FrontViewAreaNode extends cc.DrawNode {
    constructor(obj: any, _scale: any, edit: any, editedPoint: any, SVG?: any) {
       super();

        this.setName('areaCoatingNode' + obj.id);
        this._isHovered = false;
        this.selected = false;
        this.valid = true;

        this._obj = obj;
        this._spritePreview = null;
        this._svgPreview = null;

        this.edit = edit;
        this.editedPoint = editedPoint;

        var topview = this._obj.urlPreview;
        if (topview !== null && topview !== undefined && topview.length > 0) {
            var string = topview;
            this._spritePreview = new cc.Sprite(string);
            this._spritePreview.addLoadedEventListener(() => {
                var localScale = PlanManager.getInstance().frontViewLayer._scale;
                var spriteScale = Math.min(200 * localScale! / this._spritePreview.width,
                    200 * localScale! / this._spritePreview.height);
                this._spritePreview.setScale(spriteScale, spriteScale);

                var spritePos = SavaneMath.getCentroid(this._obj.vertices);
                if (this._obj.vertices.length > 2 && spritePos[0] > 0 && spritePos[0] !== Infinity) {
                    this._spritePreview.setPosition(this.convertToCocos(spritePos, localScale!));
                } else {
                    this._spritePreview.setPosition(new cc.p(100 * localScale!, 100 * localScale!));
                }

                this.addChild(this._spritePreview);
            }, this);
        }
        if (SVG) {
            this._svgPreview = new cc.Sprite(SVG);
            this._svgPreview.visible = false;
            this._svgPreview.addLoadedEventListener(() => {
                this.addChild(this._svgPreview);
            }, this);
        } 
    }

    convertToCocos(point: math.vec3, scale: number) {
        return new cc.p(point[0] * scale, point[1] * scale)
    }

    update(scale: number, drawArea: boolean) {
        drawArea = (!drawArea ? true : drawArea);

        if (this._spritePreview !== null) {
            var spriteScale = Math.min(200 * scale / this._spritePreview.width,
                200 * scale / this._spritePreview.height);
            this._spritePreview.setScale(spriteScale, spriteScale);
        }

        if (this._svgPreview !== null) {
            if (this._obj.vertices.length === 4) {
                this._svgPreview.visible = drawArea;
                var width = math.vec3.distance(this._obj.vertices[0], this._obj.vertices[1]);
                var height = math.vec3.distance(this._obj.vertices[0], this._obj.vertices[3]);
                this._svgPreview.setScale(scale * width / this._svgPreview.width, scale * height / this._svgPreview.height);
            }
        }

        var radius = 5;
        var grey = new cc.color('#1E1E3C');
        var yellow = new cc.color('#F5D231');
        var lineColor = this.valid ? new cc.color('#555b62') : new cc.color('#FF7D8D');
        var polyColorBorder;
        var polyColor;

        if (this.selected) {
            if (this.valid) {
                polyColorBorder = new cc.color(230, 230, 120, 0);
                polyColor = new cc.color(230, 230, 120, 65);
            }
            else {
                polyColorBorder = new cc.color(230, 0, 0, 0);
                polyColor = new cc.color(230, 0, 0, 65);
            }
        }
        else {
            if (this._obj.colors && this._obj.colors[this._obj._colorIndex - 1] !== undefined) {
                polyColorBorder = new cc.color(this._obj.colors[this._obj._colorIndex - 1].realColor);
                polyColor = new cc.color(this._obj.colors[this._obj._colorIndex - 1].realColor);
            }
            else {
                if (this._obj.color) {
                    polyColorBorder = new cc.color(this._obj.color.color);
                    polyColor = new cc.color(this._obj.color.color);
                }
                else if (this._obj.colors) {
                    polyColorBorder = new cc.color(this._obj.colors[0].color.color);
                    polyColor = new cc.color(this._obj.colors[0].color.color);
                } else {
                    polyColorBorder = new cc.color(0, 0, 0, 0);
                    polyColor = new cc.color(0, 0, 0, 0);
                }
            }
        }

        this.clear();

        if (this._obj.vertices.length === 0) {
            GameObjectManager.deleteDimension('DimBottomWallArea', true, this);
            GameObjectManager.deleteDimension('DimLeftWallArea', true, this);
            GameObjectManager.deleteDimension('DimBottomWallArea2', true, this);
            GameObjectManager.deleteDimension('DimLeftWallArea2', true, this);
            return;
        }

        var vertices = [];
        for (var i = 0; i < this._obj.vertices.length; ++i) {
            vertices.push(math.vec3.clone(this._obj.vertices[i]));
        }

        if (drawArea) {
            var spritePos = SavaneMath.getCentroid(this._obj.vertices);

            if (this._spritePreview !== null) {
                this._spritePreview.setPosition(this.convertToCocos(spritePos, scale));
            }

            if (this._svgPreview !== null) {
                this._svgPreview.setPosition(this.convertToCocos(spritePos, scale));
            }

            if (this._svgPreview === null) {
                var polys = SavaneMath.triangulate(vertices);
                var ccPos = null;
                if (polys !== null) {
                    for (i = 0; i < polys.length; i++) {
                        var cocosTri = [];
                        for (var j = 0; j < polys[i].length; j++) {
                            ccPos = this.convertToCocos(polys[i][j], scale);
                            cocosTri.push(ccPos);
                        }
                        this.drawPoly(cocosTri, polyColor, 1, polyColorBorder);
                    }
                }
            }
        }

        for (i = 0; i < vertices.length - 1; i++) {
            this.drawSegment(this.convertToCocos(vertices[i], scale),
                this.convertToCocos(vertices[i + 1], scale), 1, lineColor);
        }
        if (drawArea && vertices.length > 2) {
            this.drawSegment(this.convertToCocos(vertices[0], scale),
                this.convertToCocos(vertices[vertices.length - 1], scale), 1, lineColor);
        }

        for (i = 0; i < vertices.length; i++) {
            this.drawDot(this.convertToCocos(vertices[i], scale), radius + 1, grey);
            this.drawDot(this.convertToCocos(vertices[i], scale), radius, yellow);
        }

        var vertex;
        var doublePoint = false;

        switch (this.edit) {
            case 2:
                vertex = this._obj.vertices[this.editedPoint];
                break;

            case 4:
                vertex = this._obj.vertices[this._obj.vertices.length - 1];
                break;

            case 3:
                doublePoint = true;
                vertex = this._obj.vertices[this.editedPoint]
                break;

            default:
                GameObjectManager.deleteDimension('DimBottomWallArea', true, this);
                GameObjectManager.deleteDimension('DimLeftWallArea', true, this);
                GameObjectManager.deleteDimension('DimBottomWallArea2', true, this);
                GameObjectManager.deleteDimension('DimLeftWallArea2', true, this);
                return;
        }

        if (vertex) {
            GameObjectManager.createDimension('DimBottomWallArea', '',
                new cc.p((vertex[0]) * scale, 0),
                new cc.p((vertex[0]) * scale, (vertex[1]) * scale),
                new cc.p(1, 0), 0, scale * 10, true, this);
            GameObjectManager.createDimension('DimLeftWallArea', '',
                new cc.p(0, (vertex[1]) * scale),
                new cc.p((vertex[0]) * scale, (vertex[1]) * scale),
                new cc.p(1, 0), 0, scale * 10, true, this);

            if (doublePoint) {
                vertex = this._obj.vertices[(this.editedPoint + 1) % this._obj.vertices.length];
                GameObjectManager.createDimension('DimBottomWallArea2', '',
                    new cc.p((vertex[0]) * scale, 0),
                    new cc.p((vertex[0]) * scale, (vertex[1]) * scale),
                    new cc.p(1, 0), 0, scale * 10, true, this);
                GameObjectManager.createDimension('DimLeftWallArea2', '',
                    new cc.p(0, (vertex[1]) * scale),
                    new cc.p((vertex[0]) * scale, (vertex[1]) * scale),
                    new cc.p(1, 0), 0, scale * 10, true, this);
            }
        }
    }

    setEdit(edit: any, editedPoint: any, editedLine: any) {
        this.edit = edit;
        this.editedPoint = editedPoint;

        if (editedPoint === null || editedPoint === undefined) {
            this.editedPoint = editedLine;
        }
    }

    // Called when the area is closed (i.e. is a real polygon)
    setClosed(_value: any) {
    }

    toResize(position: number[], scale: number): boolean {
        return this._obj.isJoineryEntity() ? this.resizeMenu.toResize(position, scale) : false;
    }

    getZoomScale(): number {
        return 1;
    }
}
